import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Box,
  Typography,
  Container,
  Paper,
  Tabs,
  Tab,
  CircularProgress
} from '@mui/material';
import BucketManager from '../components/admin/BucketManager';
import UserManager from '../components/admin/UserManager';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `admin-tab-${index}`,
    'aria-controls': `admin-tabpanel-${index}`,
  };
}

const Admin = () => {
  const { user, loading, getUserRole } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    const checkRole = async () => {
      if (user) {
        try {
          const role = await getUserRole();
          setUserRole(role);
        } catch (error) {
          console.error('Error checking user role:', error);
        } finally {
          setRoleLoading(false);
        }
      } else if (!loading) {
        setRoleLoading(false);
      }
    };

    checkRole();
  }, [user, loading, getUserRole]);

  // Show loading spinner while checking authentication and role
  if (loading || roleLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Redirect if not logged in or not an admin
  if (!user || userRole !== 'admin') {
    return <Navigate to="/" />;
  }

  return (
    <Box sx={{ pt: 10, pb: 6 }}>
      <Container maxWidth="lg">
        <Typography variant="h4" component="h1" gutterBottom>
          Admin Dashboard
        </Typography>
        
        <Paper sx={{ mb: 4 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="primary"
            aria-label="admin tabs"
          >
            <Tab label="Storage Bucket Manager" {...a11yProps(0)} />
            <Tab label="User Management" {...a11yProps(1)} />
          </Tabs>
          
          <TabPanel value={tabValue} index={0}>
            <BucketManager />
          </TabPanel>
          
          <TabPanel value={tabValue} index={1}>
            <UserManager />
          </TabPanel>
        </Paper>
      </Container>
    </Box>
  );
};

export default Admin;
